import { Box, List, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { formatPhone } from "./lib/phone.js";

function when(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export default function ConversationList({ conversations, selected, onSelect }) {
  if (conversations.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        No conversations yet.
      </Typography>
    );
  }
  return (
    <List disablePadding sx={{ minWidth: 0 }}>
      {conversations.map((c) => (
        <ListItemButton
          key={c.number}
          selected={selected === c.number}
          onClick={() => onSelect(c.number)}
          sx={{ alignItems: "flex-start", borderBottom: "1px solid", borderColor: "divider" }}
        >
          <ListItemText
            primary={
              <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {c.person?.displayName || formatPhone(c.number)}
                </Typography>
                {c.awaitingReply ? (
                  <Box
                    component="span"
                    sx={{
                      fontSize: 11,
                      px: 0.75,
                      py: 0.1,
                      borderRadius: 1,
                      bgcolor: "kernel.attention",
                      color: "background.paper",
                    }}
                  >
                    Awaiting reply
                  </Box>
                ) : null}
              </Stack>
            }
            secondary={
              <Stack sx={{ minWidth: 0 }}>
                <Typography variant="body2" color="text.secondary" noWrap sx={{ maxWidth: "32ch" }}>
                  {c.lastMessage.direction === "outbound" ? "You: " : ""}
                  {c.lastMessage.body}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {when(c.lastMessage.sentAt)}
                </Typography>
              </Stack>
            }
          />
        </ListItemButton>
      ))}
    </List>
  );
}
